export function Name(
  key: string,
  order: "asc" | "desc" = "asc"
): (a: Record<string, unknown>, b: Record<string, unknown>) => number {
  return function innerSort(a: Record<string, unknown>, b: Record<string, unknown>): number {
    if (
      !Object.prototype.hasOwnProperty.call(a, key) ||
      !Object.prototype.hasOwnProperty.call(b, key)
    ) {
      return 0;
    }

    const varA = typeof a[key] === "string" ? (a[key] as string).toUpperCase() : a[key];
    const varB = typeof b[key] === "string" ? (b[key] as string).toUpperCase() : b[key];

    let comparison = 0;
    if ((varA as string | number) > (varB as string | number)) {
      comparison = 1;
    } else if ((varA as string | number) < (varB as string | number)) {
      comparison = -1;
    }
    return order === "desc" ? comparison * -1 : comparison;
  };
}

export function getEmail(): string | null {
  const email = localStorage.getItem("EMAIL");
  // return email;
  return email;
}
export function getIsExceptionRole(): number {
  const isException = localStorage.getItem("isException");
  if (isException == "0") {
    return 0;
  } else {
    return 1;
  }
}

export function getSenderEmail(): string | null {
  const email = localStorage.getItem("SENDER_EMAIL");
  //return email;
  return email;
}

export function getUserId(): string | null {
  const userId = localStorage.getItem("User_ID");
  return userId;
}
export function getSubTeamId(): string | null {
  const Id = localStorage.getItem("TEAM_SUB_ID");
  return Id;
}
export function getProfilePic(): string | null {
  const pic = localStorage.getItem("PROFILE_PIC");
  return pic;
}

export function getTeamID(): string | null {
  const teamId = localStorage.getItem("Team_ID");
  return teamId;
}

export function getBrandLogo(): string | null {
  const brandLogo = localStorage.getItem("BRAND_LOGO");
  return brandLogo;
}

export function getRole(): string | null {
  const role = localStorage.getItem("USER_ROLE");
  return role;
}
export function getLoginName(): string | null {
  const name = localStorage.getItem("LOGIN_NAME");
  return name;
}
export function getFullYear(): number {
  return new Date().getFullYear();
  // return "2021";
}

export function getInvoiceCount(): number {
  const count = localStorage.getItem("INVOICE_COUNT");
  return parseInt(count as string);
}
export function getApprovalAmount(): number {
  const count = localStorage.getItem("APPROVAL_AMOUNT");
  return parseInt(count as string);
}
export function getIsAddSupplier(): string | null {
  const isAddSupplier = localStorage.getItem("isAddSupplier");
  return isAddSupplier;
}
// Common Table Sorting Method
const desc = (a: Record<string, unknown>, b: Record<string, unknown>, orderBy: string): number => {
  if ((b[orderBy] as string | number) < (a[orderBy] as string | number)) {
    return -1;
  }
  if ((b[orderBy] as string | number) > (a[orderBy] as string | number)) {
    return 1;
  }
  return 0;
};

export const stableSort = <T>(array: T[], cmp: (a: T, b: T) => number): T[] => {
  const stabilizedThis: [T, number][] = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const getSorting = (
  order: string,
  orderBy: string
): ((a: Record<string, unknown>, b: Record<string, unknown>) => number) => {
  return order === "desc"
    ? (a: Record<string, unknown>, b: Record<string, unknown>) => desc(a, b, orderBy)
    : (a: Record<string, unknown>, b: Record<string, unknown>) => -desc(a, b, orderBy);
};

export const JSONParser = <T = unknown>(str: unknown, def: T): T => {
  if (typeof str === "object" && str !== null) return str as T;
  try {
    return (JSON.parse(str as string) as T) || def;
  } catch {
    return def;
  }
};

export const twoFAuth = (): string | null => {
  return localStorage.getItem("AUTH_2F");
};

interface PageSizePreset {
  label: string;
  options: number[];
  default: number;
}

// Page size presets for pagination
export const PAGE_SIZE_PRESETS: Record<string, PageSizePreset> = {
  standard: { label: "Standard (10, 20, 30)", options: [10, 20, 30], default: 10 },
  large: { label: "Large (30, 60, 90)", options: [30, 60, 90], default: 30 },
};

export function getPageSizePreset(): string {
  return localStorage.getItem("PAGE_SIZE_PRESET") || "standard";
}

export function getRowsPerPage(): number {
  const preset = PAGE_SIZE_PRESETS[getPageSizePreset()] || PAGE_SIZE_PRESETS.standard;
  return preset.default;
}

export function getPageSizeOptions(): number[] {
  const preset = PAGE_SIZE_PRESETS[getPageSizePreset()] || PAGE_SIZE_PRESETS.standard;
  return preset.options;
}

// Invoice navigation scope
interface InvoiceNavScope {
  label: string;
}

export const INVOICE_NAV_SCOPES: Record<string, InvoiceNavScope> = {
  all: { label: "All invoices" },
  pending: { label: "Pending invoices only" },
};

export function getInvoiceNavScope(): string {
  return localStorage.getItem("INVOICE_NAV_SCOPE") || "all";
}
